<select
  id="languageSelect"
  class="form-select form-select-sm"
  [ngModel]="currentLocale"
  (ngModelChange)="switchLanguage($event)"
  aria-label="Select language"
  i18n-aria-label="label|Accessible label for the language selector@@languageSelectorAriaLabel"
>
  @for (language of languages; track language.code) {
    <option [value]="language.code">
      {{ language.label }}
    </option>
  }
</select>
